const ui_assets = require('./ui_assets');
const ui_button = require('./ui_button');
const ui_component = require('./ui_component');
const ui_container = require('./ui_container');
const ui_input = require('./ui_input');
const ui_utils = require('./ui_utils');

module.exports = {
	...ui_assets,
	...ui_button,
	...ui_component,
	...ui_container,
	...ui_input,
	...ui_utils,
}
